import { isNull } from '@app/utils'

import { ObservableService } from '@app/services/observableService'

import storageService from '@app/services/storageService'

import type { Storage } from '@app/types'
import type { Session, JwtSessionServiceOptions } from './types'

const SESSION = 'session'
const SESSION_CHANGE_SUB = 'SESSION_CHANGE_SUB'

export class JwtSessionService extends ObservableService {
  readonly #storage: Storage

  constructor ({ storage }: JwtSessionServiceOptions) {
    super()

    this.#storage = storage
  }

  getSession (): Session | null {
    const tokenInfo = this.#storage.getItem(SESSION)

    if (isNull(tokenInfo)) return tokenInfo

    try {
      return JSON.parse(tokenInfo)
    } catch {
      this.clearSession()
      return null
    }
  }

  setSession (session: Session): void {
    this.#storage.setItem(SESSION, JSON.stringify(session))

    this.broadcast(SESSION_CHANGE_SUB)
  }

  clearSession (): void {
    this.#storage.removeItem(SESSION)

    this.broadcast(SESSION_CHANGE_SUB)
  }

  subscribeToSessionChange (subscriber: () => void): void {
    this.subscribe(SESSION_CHANGE_SUB, subscriber)
  }

  unsubscribeToSessionChange (subscriber: () => void): void {
    this.unsubscribe(SESSION_CHANGE_SUB, subscriber)
  }
}

const jwtSessionService = new JwtSessionService({ storage: storageService })

export default jwtSessionService
